import { call, put, takeEvery, takeLatest } from "redux-saga/effects";

import { venderApi } from "../../../api/user/venderApi";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { eVenderActionIds, IVenderActionTypes } from "../../action-types/user/IVenderActionTypes";
import { actions } from "../../actions";
import { IVender } from "../../../model/respone/user/IVender";
const mainAction = actions.vender;
export function* venderSaga(): any {
  yield takeLatest(eVenderActionIds.LOAD_START, loadWorker);
  yield takeEvery(eVenderActionIds.SAVE_START, saveWorker);
  yield takeEvery(eVenderActionIds.DELETE_START, deleteWorker);
}

function* loadWorker(): any {
  const res: IBaseRespone = yield call(venderApi.SelectAll);
  if (res.is_success) {
    yield put(mainAction.LOAD_SUCCESS(res.data));
  } else {
    yield put(mainAction.LOAD_ERRR(res.message ?? "Có lỗi"));
  }
}

function* saveWorker(action: IVenderActionTypes): any {
  const payload = action.payload as IVender;
  let res: IBaseRespone;
  if (payload.id > 0) {
    res = yield call(venderApi.Update, payload);
  } else {
    res = yield call(venderApi.Insert, payload);
  }
  if (res.is_success) {
    yield put(mainAction.SAVE_SUCCESS(res.data));
  } else {
    yield put(mainAction.SAVE_ERRR(res.message ?? "Có lỗi"));
  }
}

function* deleteWorker(action: IVenderActionTypes): any {
  const res: IBaseRespone = yield call(venderApi.Delete, action.payload as number);
  if (res.is_success) {
    yield put(mainAction.DELETE_SUCCESS(res.data));
  } else {
    yield put(mainAction.DELETE_ERRR(res.message ?? "Có lỗi"));
  }
}